/**
 * Snow Monkey Form のボタンをメインボタン構造に変換
 * お問い合わせページ・採用お問い合わせページのみ適用
 */
function getButtonLabel(button: HTMLButtonElement): string {
  const sendingSpan = button.querySelector('.smf-sending');
  const clone = button.cloneNode(true) as HTMLButtonElement;
  if (sendingSpan) {
    clone.querySelector('.smf-sending')?.remove();
  }
  return clone.textContent?.trim() || '';
}

function transformButton(button: HTMLButtonElement): void {
  if (button.closest('.main-button')) return; // すでに変換済み

  const dataAction = button.getAttribute('data-action') || '';
  const label = getButtonLabel(button);

  // 戻るボタンは DOM を書き換えない（SMF 側の判定/イベントと競合しやすいため）
  // 見た目は SCSS 側でテキストリンク化する。
  if (dataAction === 'back') {
    button.classList.add('smf-back-link');
    return;
  }

  const modifierClass = dataAction === 'back' ? 'main-button --back' : 'main-button --medium --center';

  const wrapper = document.createElement('div');
  wrapper.className = modifierClass;

  const smfControl = document.createElement('span');
  smfControl.className = 'smf-button-control';

  // SMF の JS がこのクラスでボタンを識別するため削除しない
  button.classList.add('main-button__link');

  const existingSending = button.querySelector('.smf-sending') as HTMLElement | null;
  existingSending?.remove(); // 後で付け直す
  button.innerHTML = '';

  const hoverShutter = document.createElement('span');
  hoverShutter.className = 'hover-shutter';
  hoverShutter.innerHTML = `
    <span class="hover-shutter__text">${escapeHtml(label)}</span>
    <span class="hover-shutter__text">${escapeHtml(label)}</span>
  `;

  const iconBorder = document.createElement('span');
  iconBorder.className = 'icon-border';

  const iconArrow = document.createElement('span');
  iconArrow.className = 'icon-arrow';

  const sendingSpan = existingSending ?? document.createElement('span');
  sendingSpan.className = 'smf-sending';
  sendingSpan.setAttribute('aria-hidden', 'true');

  // 戻るボタンは矢印を左に配置 [矢印][境界線][テキスト]
  if (dataAction === 'back') {
    button.appendChild(iconArrow);
    button.appendChild(iconBorder);
    button.appendChild(hoverShutter);
  } else {
    button.appendChild(hoverShutter);
    button.appendChild(iconBorder);
    button.appendChild(iconArrow);
  }
  button.appendChild(sendingSpan);

  const parent = button.parentElement;
  if (!parent) return;

  const nextSibling = button.nextSibling;
  smfControl.appendChild(button);
  wrapper.appendChild(smfControl);

  if (parent.classList.contains('smf-button-control')) {
    parent.replaceWith(wrapper);
  } else {
    parent.insertBefore(wrapper, nextSibling);
  }
}

function escapeHtml(text: string): string {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

function transformActionArea(actionArea: Element): void {
  const buttons = actionArea.querySelectorAll('button.smf-button-control__control[data-action]');
  buttons.forEach((btn) => transformButton(btn as HTMLButtonElement));
}

function initSmfFormButton(): void {
  // お問い合わせページ・採用お問い合わせページのみ
  const isContactPage =
    document.body.classList.contains('page-contact') ||
    document.body.classList.contains('page-recruit-contact') ||
    window.location.pathname.includes('contact');

  if (!isContactPage) return;

  const forms = document.querySelectorAll('.snow-monkey-form');
  forms.forEach((form) => {
    const actionArea = form.querySelector('.smf-action');
    if (!actionArea) return;

    // 初回実行
    transformActionArea(actionArea);

    // フォーム内容が動的に差し替えられるため MutationObserver で監視
    const observer = new MutationObserver(() => {
      transformActionArea(actionArea);
    });

    observer.observe(actionArea, {
      childList: true,
      subtree: true,
    });
  });
}

export function smfFormButton(): void {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSmfFormButton);
  } else {
    initSmfFormButton();
  }
}
